import styled from 'styled-components';

export const MainWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    padding: calc(var(--yat_exp-page-padding) * 2) var(--yat_exp-page-padding);

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: grid;
        align-items: center;
    }
`;
